import { useState } from 'react'

const useDragSort = onReorder => {
  const [dragging, setDragging] = useState(false)

  const onSortStart = () => {
    setDragging(true)
    document.body.style.cursor = 'grabbing'
  }

  const onSortEnd = event => {
    onReorder(event)
    setDragging(false)
    document.body.style.cursor = 'inherit'
  }

  return { dragging, onSortStart, onSortEnd }
}

export default useDragSort
